import { render, staticRenderFns } from "./Running.vue?vue&type=template&id=4452be82&scoped=true&"
import script from "./Running.vue?vue&type=script&lang=js&"
export * from "./Running.vue?vue&type=script&lang=js&"
import style0 from "./Running.vue?vue&type=style&index=0&id=4452be82&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4452be82",
  null
  
)

export default component.exports